import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import LoadingIcon from 'Components/icons/LoadingIcon';
import OrderShipToDetail from 'Components/commonOrder/OrderShipToDetail';
import HostShipmentDetailCard from 'Components/host/HostShipmentDetailCard';
import HostShipmentDetailsDialogs from 'Components/host/HostShipmentDetailsDialogs';
import {ArrowBackIos} from '@material-ui/icons';
import {T} from 'Actions/translate';
import {openNotification} from 'Actions/notification';
import {
    b2bCasmartShipment,
    cancelPackage,
    createInvoicePdf,
    getOrderDetailMessageCount,
    getOrderDetailOneKeyRead,
    getHostShipmentDetails,
    punchReceivable,
    setCurrentShipmentId,
    setRevokePackageSuccess,
    updateTrackingNumber,
} from 'Actions/host';

class HostShipmentDetails extends React.Component {
    state = {
        hostShipmentDetail: null,
        isLoading: true,
        isReceiveDialogOpened: false,
        isWithdrawalDialogOpened: false,
        isWithdrawalPending: false,
        isTrackingDialogOpened: false,
        isPlacementPreviewOpened: false,
        trackingNumber: '',
        uploadFileBtnIsLoading: false,
        messageCount: {},
    };

    componentDidMount() {
        this.loadShipmentDetail();
    }

    getShipmentId = () => {
        const searchParams = new URLSearchParams(this.props.location.search);
        return searchParams.get('shipmentId');
    };

    getShipmentCard = () => {
        const {hostShipmentDetail} = this.state;
        return hostShipmentDetail ? hostShipmentDetail.shipmentCard : null;
    };

    loadShipmentDetail = () => {
        const shipmentId = this.getShipmentId();
        if (!shipmentId) {
            this.setState({isLoading: false});
            this.props.openNotification(
                T('notification_please_select_package'),
                'danger',
            );
            return;
        }

        this.setState({isLoading: true});
        this.props
            .getHostShipmentDetails({shipmentId})
            .then((res) => {
                const hostShipmentDetail = res.data;
                this.setState({
                    hostShipmentDetail,
                    isLoading: false,
                });
                if (hostShipmentDetail && hostShipmentDetail.eoneNumber) {
                    this.loadMessageCount(hostShipmentDetail.eoneNumber);
                }
            })
            .catch((error) => {
                console.error('Failed to load host shipment detail:', error);
                this.setState({isLoading: false});
                this.props.openNotification(
                    T('notification_network_unstable'),
                    'danger',
                );
            });
    };

    goBack = () => this.props.history.goBack();

    loadMessageCount = (eoneNumber) => {
        this.props
            .getOrderDetailMessageCount({
                messageKey: eoneNumber,
                messageMode: 'ORDER',
            })
            .then((res) => {
                if (res && res.status === 'success' && res.data) {
                    this.setState({messageCount: res.data});
                }
            });
    };

    goToMessageList = () => {
        const {hostShipmentDetail, messageCount} = this.state;
        if (!hostShipmentDetail || !hostShipmentDetail.eoneNumber) {
            return;
        }
        if (messageCount.unReadCount > 0) {
            this.props
                .getOrderDetailOneKeyRead({
                    messageKey: hostShipmentDetail.eoneNumber,
                    messageMode: 'ORDER',
                })
                .then((res) => {
                    if (res && res.status === 'success') {
                        this.props.history.push(
                            `/messageList?eoneNumber=${hostShipmentDetail.eoneNumber}`,
                        );
                    }
                });
            return;
        }
        this.props.history.push(
            `/messageList?eoneNumber=${hostShipmentDetail.eoneNumber}`,
        );
    };

    openReceiveDialog = () => {
        const shipmentCard = this.getShipmentCard();
        if (!shipmentCard) {
            this.props.openNotification(
                T('notification_please_select_package'),
                'danger',
            );
            return;
        }

        this.props.punchReceivable(shipmentCard.shipmentId).then((res) => {
            if (!res || res.status !== 'success') {
                return;
            }
            const punchData = res.data || {};
            const {punchEnabled, hasPunched} = punchData;
            if (punchEnabled === 'Y' && hasPunched !== 'Y') {
                this.props.openNotification(
                    T('shippment_upload_signed_first_punch'),
                    'danger',
                );
                return;
            }
            this.setState({isReceiveDialogOpened: true});
        });
    };

    closeReceiveDialog = () => this.setState({isReceiveDialogOpened: false});

    handleReceiveSuccess = () => {
        this.props.openNotification(
            T('notification_confirmed_the_customer_receipt'),
            'success',
            {time: 2000},
        );
        this.closeReceiveDialog();
        this.props.history.goBack();
    };

    openWithdrawalDialog = () =>
        this.setState({isWithdrawalDialogOpened: true});

    closeWithdrawalDialog = () => {
        if (!this.state.isWithdrawalPending) {
            this.setState({isWithdrawalDialogOpened: false});
        }
    };

    withdrawPackage = () => {
        const shipmentCard = this.getShipmentCard();
        if (!shipmentCard || this.state.isWithdrawalPending) {
            return;
        }

        this.setState({isWithdrawalPending: true});
        this.props
            .cancelPackage({id: shipmentCard.shipmentId})
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState(
                        {
                            isWithdrawalDialogOpened: false,
                            isWithdrawalPending: false,
                        },
                        () => {
                            this.props.setRevokePackageSuccess({$set: true});
                            this.props.setCurrentShipmentId({
                                $set: shipmentCard.shipmentId,
                            });
                            this.props.openNotification(
                                T('package_withdrawn_successfully'),
                                'success',
                            );
                            setTimeout(this.goBack, 400);
                        },
                    );
                    return;
                }
                this.handleWithdrawalFailure();
            })
            .catch(this.handleWithdrawalFailure);
    };

    handleWithdrawalFailure = () => {
        this.setState({
            isWithdrawalDialogOpened: false,
            isWithdrawalPending: false,
        });
        this.props.openNotification(T('failed_to_withdraw_package'), 'danger');
    };

    openTrackingDialog = () => {
        const shipmentCard = this.getShipmentCard();
        this.setState({
            isTrackingDialogOpened: true,
            trackingNumber: shipmentCard.expressNumber || '',
        });
    };

    updateTrackingNumber = () => {
        const shipmentCard = this.getShipmentCard();
        const trackingNumber = this.state.trackingNumber.trim();
        if (!shipmentCard || !trackingNumber) {
            return;
        }
        this.props
            .updateTrackingNumber({
                shipmentId: shipmentCard.shipmentId,
                expressNumber: trackingNumber,
            })
            .then(() => {
                this.props.openNotification(
                    T('shippment_update_tracking_number_success'),
                    'success',
                    {time: 2000},
                );
                this.setState(
                    {isTrackingDialogOpened: false, trackingNumber: ''},
                    this.loadShipmentDetail,
                );
            });
    };

    previewInvoice = () => {
        const shipmentCard = this.getShipmentCard();
        if (!shipmentCard) {
            return;
        }
        this.props
            .createInvoicePdf({id: shipmentCard.shipmentId})
            .then((res) => {
                const url =
                    window.location.origin +
                    '/pdf-preview/pdf-preview.html?url=' +
                    window.encodeURIComponent(
                        `${util.getImageRoot() + res.data}`,
                    );
                if (util.isIOS()) {
                    window.location.href = url;
                    return;
                }
                window.open(url, '_blank');
            });
    };

    previewB2bShipment = (params) => {
        this.props
            .b2bCasmartShipment(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    if (util.isWechatBrowser()) {
                        const url =
                            window.location.origin +
                            '/pdf-preview/pdf-preview.html?url=' +
                            window.encodeURIComponent(
                                `${util.getImageRoot() + res.data}`,
                            );
                        if (util.isIOS()) {
                            window.location.href = url;
                        } else {
                            window.open(url, '_blank');
                        }
                        return;
                    }
                    window.open(res.data, '_blank');
                    return;
                }
                this.props.openNotification(
                    res && res.message
                        ? T(res.message)
                        : T('notification_network_unstable'),
                    'danger',
                );
            })
            .catch((error) => {
                if (error && error.status === 'po_number_empty') {
                    this.props.openNotification(T('po_number_empty'), 'danger');
                    return;
                }
                if (
                    error &&
                    error.status === 'b2b_shipment_integration_error'
                ) {
                    this.props.openNotification(
                        T('order_contact_service'),
                        'danger',
                    );
                    return;
                }
                this.props.openNotification(
                    error && error.message
                        ? T(error.message)
                        : T('notification_network_unstable'),
                    'danger',
                );
            });
    };

    getPreviewImageUrl = (imageUrl) =>
        /^https?:\/\//.test(imageUrl)
            ? imageUrl
            : util.getImageRoot() + imageUrl;

    render() {
        const {
            hostShipmentDetail,
            isLoading,
            isReceiveDialogOpened,
            isWithdrawalDialogOpened,
            isWithdrawalPending,
            isTrackingDialogOpened,
            isPlacementPreviewOpened,
            trackingNumber,
            uploadFileBtnIsLoading,
            messageCount,
        } = this.state;
        const shipmentCard = this.getShipmentCard();

        return (
            <div className="deliver-details-container host-shipment-details-container">
                <div className="header-wrap">
                    <div className="shipment-details-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        <h3>{T('shipment_details')}</h3>
                        {messageCount && messageCount.messageCount > 0 ? (
                            <div className="message-count-container">
                                {messageCount.unReadCount > 0 ? (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_unread_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                ) : (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_read_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
                {isLoading ? (
                    <div className="delivery-details-loading">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : hostShipmentDetail && shipmentCard ? (
                    <div>
                        <div className="content-box">
                            <p className="order-number">
                                <label>{T('shippment_order_number')}</label>
                                <span>{hostShipmentDetail.number}</span>
                            </p>
                            <p className="eone-order-number">
                                <label>{T('shippment_eone_number')}</label>
                                <span>{hostShipmentDetail.eoneNumber}</span>
                            </p>
                            <p className="cancel-time">
                                <label>{T('shippment_purchase_date')}</label>
                                <span>{hostShipmentDetail.createTime}</span>
                            </p>
                        </div>
                        <ul className="shipment-card-ul">
                            <HostShipmentDetailCard
                                shipmentCard={shipmentCard}
                                orderId={hostShipmentDetail.id}
                                roleType={this.props.localData.roleType}
                                onPreviewInvoice={this.previewInvoice}
                                onEditTrackingNumber={this.openTrackingDialog}
                                onPreviewPlacementImage={() =>
                                    this.setState({
                                        isPlacementPreviewOpened: true,
                                    })
                                }
                                onPreviewB2bShipment={this.previewB2bShipment}
                            />
                        </ul>
                        <OrderShipToDetail
                            className="ship-to-info"
                            data={hostShipmentDetail}
                        />
                        <Anchor
                            className="host-shipment-full-order"
                            onClickOfSingleTap={() =>
                                this.props.history.push(
                                    `/shipmentDetails?orderId=${hostShipmentDetail.id}&eoneNumber=${hostShipmentDetail.eoneNumber}&tabFlag=4`,
                                )
                            }>
                            {T('shippment_view_all_order_information')}
                            <span>
                                {T('shippment_total_pieces', [
                                    hostShipmentDetail.orderQuantity,
                                ])}
                            </span>
                        </Anchor>
                        <div className="footer-warp">
                            <div className="shipment-details-footer container-max-width is-fixed">
                                <BasicButton
                                    className="cancel-btn withdrawal_of_package"
                                    type="info"
                                    onClickOfSingleTap={
                                        this.openWithdrawalDialog
                                    }>
                                    {T('withdrawal_of_package')}
                                </BasicButton>
                                <BasicButton
                                    className="receive-btn"
                                    type="primary"
                                    onClickOfSingleTap={this.openReceiveDialog}>
                                    {T('shippment_take_goods')}
                                </BasicButton>
                            </div>
                        </div>
                    </div>
                ) : null}
                <HostShipmentDetailsDialogs
                    hostShipmentDetail={hostShipmentDetail}
                    shipmentCard={shipmentCard}
                    isReceiveDialogOpened={isReceiveDialogOpened}
                    isWithdrawalDialogOpened={isWithdrawalDialogOpened}
                    isWithdrawalPending={isWithdrawalPending}
                    isTrackingDialogOpened={isTrackingDialogOpened}
                    isPlacementPreviewOpened={isPlacementPreviewOpened}
                    trackingNumber={trackingNumber}
                    uploadFileBtnIsLoading={uploadFileBtnIsLoading}
                    getPreviewImageUrl={this.getPreviewImageUrl}
                    onCloseReceive={this.closeReceiveDialog}
                    onCloseWithdrawal={this.closeWithdrawalDialog}
                    onWithdraw={this.withdrawPackage}
                    onCloseTracking={() =>
                        this.setState({isTrackingDialogOpened: false})
                    }
                    onTrackingNumberChange={(name, value) =>
                        this.setState({trackingNumber: value})
                    }
                    onUpdateTrackingNumber={this.updateTrackingNumber}
                    onClosePlacementPreview={() =>
                        this.setState({isPlacementPreviewOpened: false})
                    }
                    onReceiveLoadingChange={(loading) =>
                        this.setState({uploadFileBtnIsLoading: loading})
                    }
                    onReceiveSuccess={this.handleReceiveSuccess}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    localData: state.localData,
});

const mapDispatchToProps = {
    b2bCasmartShipment,
    cancelPackage,
    createInvoicePdf,
    getOrderDetailMessageCount,
    getOrderDetailOneKeyRead,
    getHostShipmentDetails,
    openNotification,
    punchReceivable,
    setCurrentShipmentId,
    setRevokePackageSuccess,
    updateTrackingNumber,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(HostShipmentDetails);
